// extracted by mini-css-extract-plugin
export default {"Loading":"Preloader_Loading__sZCxj","circle":"Preloader_circle__XE6IU","spinner-border":"Preloader_spinner-border__PJ0NM","spin":"Preloader_spin__0JVqO"};